import { Input } from "@angular/core";
import { DateRangeUnits } from "../components/common/date-picker/date-picker.component";

export const StorageKeys = {
  LOGIN_METHOD: "loginMethod",
  MENU_ITEMS: "menuItems",
  USER_PROFILE: "userProfile",
  USER_PERMISSIONS: "userPermissions"
} as const;

export const LOCALES = {
  EN_IN: { value: "en-IN" },
  EN_US: { value: "en-US" }
};
export const LOCALE = LOCALES.EN_IN.value;


export const CycleType = {
  IMPORT: { value: "Import", key: "IMPORT" },
  EXPORT: { value: "Export", key: "EXPORT" },
  EMPTY: { value: "Empty", key: "EMPTY" },
  BOND: { value: "Bond", key: "BOND" },
  BUFFER: { value: "Buffer", key: "BUFFER" }
} as const;
export type Cycle = typeof CycleType[keyof typeof CycleType];

export const PaymentMode = {
  NEFT: { value: "NEFT", key: "NEFT" },
  RTGS: { value: "RTGS", key: "RTGS" },
  CASH: { value: "CASH", key: "CASH" },
  PDA: { value: "PDA", key: "PDA" },
  CHEQUE: {value: "CHEQUE", key: "CHEQUE" },
} as const;
export type PaymentMode = typeof PaymentMode[keyof typeof PaymentMode];


export const BooleanType = {
  TRUE: { value: "Yes", key: true },
  FALSE: { value: "No", key: false }
} as const;
export type BooleanType = typeof BooleanType[keyof typeof BooleanType];

export const AttributeType = {
  STRING: { value: "String", key: "STRING" },
  BOOLEAN: { value: "Boolean", key: "BOOLEAN" },
  BIGDECIMAL: { value: "Number", key: "BIGDECIMAL" }
} as const;
export type AttributeType = typeof AttributeType[keyof typeof AttributeType];

export const InventoryType = {
  CONTAINER: { value: "Container", key: "CONTAINER" },
  TRAILER: { value: "Trailer", key: "TRAILER" },
  WAREHOUSE: { value: "Warehouse", key: "WAREHOUSE" },
  TRUCK: { value: "Truck", key: "TRUCK" },
  CARGO: { value: "Cargo", key: "CARGO" }
} as const;
export type InventoryType = typeof InventoryType[keyof typeof InventoryType];

export const ExaminationType = {
  SEAL_CUT_AND_EXAMINATION: { value: "Seal Cut and Examination", key: "SEAL_CUT_AND_EXAMINATION" },
  RMS_AND_EXAMINATION: { value: "RMS and Examination", key: "RMS_AND_EXAMINATION" },
  RMS: { value: "RMS", key: "RMS" }
} as const;
export type ExaminationType = typeof ExaminationType[keyof typeof ExaminationType];

export const ServiceTypes = {
  SPECIAL_SERVICE: { name: "Special Service", value: "SPECIAL_SERVICE" },
  GENERAL_SERVICE: { name: "General Service", value: "GENERAL_SERVICE" }
} as const;
export type ServiceTypes = typeof ServiceTypes[keyof typeof ServiceTypes];


export const LocationTypes = {
  PORT: { name: "Port", value: "PORT" },
  INLAND_CONTAINER_DEPOT: { name: "Inland Container Depot", value: "INLAND_CONTAINER_DEPOT" },
  CFS: { name: "CFS", "value": "CFS" },
  EMPTY_DEPOT: { name: "Empty Depot", value: "EMPTY_DEPOT" },
  BERTHING_POINT: { name: "Berthing Point", value: "BERTHING_POINT" },
  REPAIRING_YARD: { name: "Repairing Yard", value: "REPAIRING_YARD" }

} as const;
export type LocationTypes = typeof LocationTypes[keyof typeof LocationTypes];


export const CustomerTypes = {
  FREIGHT_FORWARDER: { name: "Freight Forwarder", value: "FREIGHT_FORWARDER" },
  CONSIGNEE: { name: "Consignee", value: "CONSIGNEE" },
  LINE_AGENT: { name: "Line Agent", value: "LINE_AGENT" },
  LINE: { name: "Line", value: "LINE" },
  CHA: { name: "CHA", value: "CHA" },
  TRANSPORTER: { name: "Transporter", value: "TRANSPORTER" },
  SHIPPER: { name: "Shipper", value: "SHIPPER" },
  EXPORTER: { name: "Exporter", value: "EXPORTER" },
  GROUP_COMPANY: { name: "Group Company", value: "GROUP_COMPANY" },
  BROKER: { name: "Broker", value: "BROKER" },
  OTHER_CFS: { name: "Other CFS", value: "OTHER_CFS" }
} as const;
export type CustomerTypes = typeof CustomerTypes[keyof typeof CustomerTypes];


export const JobOrderStatusTypes = {
  COMPLETED: { name: "Completed", value: "COMPLETED" },
  CANCELLED: { name: "Cancelled", value: "CANCELLED" },
  // EXPIRED: { name: "Expired", value: "EXPIRED" },
  PENDING: { name: "Pending", value: "PENDING" }
} as const;
export type JobOrderStatusTypes = typeof JobOrderStatusTypes[keyof typeof JobOrderStatusTypes];

export enum PageAction {
  INSERT = "INSERT",
  UPDATE = "UPDATE",
  VIEW = "VIEW"
}

export function isViewAction(action: PageAction) {
  return action === PageAction.VIEW;
}

export function isEditAction(action: PageAction) {
  return action === PageAction.UPDATE;
}

export function isInsertAction(action: PageAction) {
  return action === PageAction.INSERT;
}

export const REPLACE_KEY = "REPLACE";

// Const Variables
export const PAN_NUMBER_REGEX = "^[A-Z]{5}[0-9]{4}[A-Z]{1}$";
export const ENTITY_NAME_REGEX = "^[A-Za-z0-9\\s]+$";


export const ImportType = {
  LCL: { value: "LCL", key: "LCL" },
  FCL: { value: "FCL", key: "FCL" }
} as const;
export type ImportType = typeof ImportType[keyof typeof ImportType];

export const DocumentType = {
  BOE: { value: "BOE", key: "BOE" },
  SHIPPING_BILL: { value: "Shipping Bill", key: "SHIPPING_BILL" },
  EX_BOE: { value: "Ex-BOE", key: "EX_BOE" }
} as const;
export type DocumentType = typeof DocumentType[keyof typeof DocumentType];

export const BOE_TYPE = {
  IMPORT: { label: "Import", value: "IMPORT" },
  BOND: { label: "Bond", value: "BOND" }
};
export type BOE_TYPE = typeof BOE_TYPE[keyof typeof BOE_TYPE];


export const WEIGHING_LOAD_TYPES = {
  TRAILER: {
    key: "TRAILER",
    value: "Trailer/Truck"
  },
  TRAILER_CONTAINER: {
    key: "TRAILER_CONTAINER",
    value: "Trailer + Container"
  },
  TRAILER_DOUBLE_CONTAINER: {
    key: "TRAILER_DOUBLE_CONTAINER",
    value: "Trailer + Double Container"
  },
  CONTAINER: {
    key: "CONTAINER",
    value: "Container"
  },
  CARGO: { key: "CARGO", value: "Cargo" }
};
export type WeighingLoadType = typeof WEIGHING_LOAD_TYPES[keyof typeof WEIGHING_LOAD_TYPES];

export enum WEIGHT_RECORD_STATUS {
  PENDING = "PENDING",
  COMPLETED = "COMPLETED",
}

export enum WEIGHT_MEASUREMENT {
  KG = "KG",
  LBS = "Lbs"
}

export const DATE_CONFIG = {
  maxRangeFromCurrent: 1,
  minRangeFromCurrent: -10,
  rangeUnit: 'years' as DateRangeUnits,
  minRangeUnit: 'years' as DateRangeUnits,
  maxRangeUnit: 'years' as DateRangeUnits
}

export const DEFAULT_DATETIME_TIME = {
  hour: 8,
  minute: 0,
  second: 0
}

export const DEFAULT_WEIGHT_MEASUREMENT_UNIT = WEIGHT_MEASUREMENT.KG;

export const CURRENCY_CODE = 'INR';

export const ALERT_TYPE = {
  USER: 'USER',
  CUSTOMER: 'CUSTOMER',
  REPORT: 'REPORT'
}

export const CHARGE_SELECTION_MODE = {
  ALL_CHARGES: { value: 'ALL_CHARGES', label: 'All Charges' },
  PERIOD_CHARGES_ONLY: { value: 'PERIOD_CHARGES_ONLY', label: 'Period Charges Only'},
  ALL_EXCEPT_PERIOD_CHARGES: { value: 'ALL_EXCEPT_PERIOD_CHARGES', label: 'All Except Period Charges' }
}

export const CUSTOMER_PORTAL_ENABLED = true

export const PortalRole = {
  ADMIN: { value: 'admin', label: 'Admin' },
  USER: { value: 'user', label: 'User' },
}

export const FUZZY_MAX_DISTANCE = 1;

export const CREDIT_NOTE_INVOICE_DATE_WINDOW_DAYS = 7;
